import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import {
    POHOTOVOST_URL,
    POHOTOVOST_VSECHNY_URL,
    POHOTOVOST_BY_ID_URL,
    POHOTOVOST_UZAVRIT_URL,
    POHOTOVOST_ODPOVEDI_URL,
} from "../url";
import type { Pohotovost, PohotovostOdpoved, CreatePohotovostRequest } from "../generated/models/Pohotovost";

const getAktivni = () =>
    handleRequest<Pohotovost[]>(() => axiosInstance.get(POHOTOVOST_URL));

const getVsechny = () =>
    handleRequest<Pohotovost[]>(() => axiosInstance.get(POHOTOVOST_VSECHNY_URL));

const getById = (id: number) =>
    handleRequest<Pohotovost>(() => axiosInstance.get(POHOTOVOST_BY_ID_URL(id)));

const vytvorit = (data: CreatePohotovostRequest) =>
    handleRequest<Pohotovost>(() => axiosInstance.post(POHOTOVOST_URL, data));

const upravit = (id: number, data: CreatePohotovostRequest) =>
    handleRequest<void>(() => axiosInstance.put(POHOTOVOST_BY_ID_URL(id), data));

const uzavrit = (id: number) =>
    handleRequest<void>(() => axiosInstance.put(POHOTOVOST_UZAVRIT_URL(id)));

const getOdpovedi = (id: number) =>
    handleRequest<PohotovostOdpoved[]>(() => axiosInstance.get(POHOTOVOST_ODPOVEDI_URL(id)));

const PohotovostService = { getAktivni, getVsechny, getById, vytvorit, upravit, uzavrit, getOdpovedi };
export default PohotovostService;
